var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#check_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 2.533a8 8 0 0 0-1.936.088 3.5 3.5 0 0 0-1.304.508c-.405.273-1.323 1.133-1.847 1.7-.523.566-.909.977-1.936 2.266a177 177 0 0 0-2.647 3.42c-1.077 1.426-1.65 2.11-1.808 2.11-.266 0-.424-.361-.573-1.065-.059-.313-.118-.567-.158-.752-.217-1.124-.859-.86-1.402-.635a1.715 1.715 0 0 0-1.097 1.788c.02.195 0 .107.109.918.01.068.198 1.446.286 1.827.07.322.168.635.317.938.118.244.296.469.523.625.237.147.514.235.8.264.87.107 1.452-.215 2.37-1.26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.918 21.487c-2.42 0-4.267-.704-5.521-2.091-1.265-1.407-1.897-3.41-1.897-6.018 0-2.668.662-4.71 1.976-6.136 1.313-1.426 3.22-2.15 5.709-2.15 1.689 0 3.21.313 4.563.929L12.04 8.395c-1.472-.479-1.946-.498-2.875-.498-2.766 0-4.158 1.817-4.158 5.451 0 1.778.345 3.107 1.037 3.996q1.034 1.337 3.032 1.339a8.77 8.77 0 0 0 4.297-1.114V20.5a7 7 0 0 1-1.946.762c-.83.156-1.67.235-2.509.225"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "check_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.445h21v19.11h-21z"
  })))));
};
export default SvgCheck;